import { stringToBoolean } from "../index";
import { ChevronLeft } from "../../assets/svgs";
import {
  StepHeader,
  DashboardHeader,
  Header,
  CampaignHeader,
} from "../../components";
import { HEADER_TYPES } from "../../constants";
import { getSvgComponent } from "../svgUtils";
import { safeJsonParse } from "../index";

// header component mapping
export const HEADER_COMPONENT_MAPPING = {
  [HEADER_TYPES.STEPPER]: (props) => <StepHeader {...props} />,
  [HEADER_TYPES.DASHBOARD_HEADER]: (props) => <DashboardHeader {...props} />,
  [HEADER_TYPES.DEFAULT_HEADER]: (props) => <Header {...props} />,
  [HEADER_TYPES.ONBOARDING_HEADER]: (props) => <CampaignHeader {...props} />,
};

export const headerSchema = (components, mapping) => {
  return components
    .map((item) => {
      switch (item.attributes.type) {
        case HEADER_TYPES.STEPPER:
          return {
            Component: mapping[HEADER_TYPES.STEPPER],
            props: {
              title: item.attributes.title,
              currentStep: item.attributes.currentStep,
              totalSteps: item.attributes.totalSteps,
              stepperIcon: item.attributes.stepperIcon,
              backEnable: stringToBoolean(item?.attributes?.backEnable),
              hideBackButton: item.attributes?.hide_back_button,
              showBar: item.attributes?.show_bar,
              showLogo: item.attributes?.show_logo,
              type: HEADER_TYPES.STEPPER,
            },
          };
        case HEADER_TYPES.DASHBOARD_HEADER: {
          return {
            Component: mapping[HEADER_TYPES.DASHBOARD_HEADER],
            props: {
              type: HEADER_TYPES.DASHBOARD_HEADER,
              components: item.components,
              isFinanceDetail: stringToBoolean(item.attributes.isFinanceDetail),
              loanAmountText: item.attributes.loanAmountText,
              loanLabelText: item.attributes.loanLabelText,
              welcomeHeading: item.attributes?.welcomeHeading,
              value: item.attributes?.value,
            },
          };
        }
        case HEADER_TYPES.DEFAULT_HEADER:
          return {
            Component: mapping[HEADER_TYPES.DEFAULT_HEADER],
            props: {
              type: HEADER_TYPES.DEFAULT_HEADER,
              backEnable: stringToBoolean(item?.attributes?.backEnable),
              icon: item?.attributes?.icon
                ? getSvgComponent(item?.attributes?.icon)
                : ChevronLeft,
              rightIcon: getSvgComponent(item?.attributes?.rightIcon),
              onRightIconClick: item?.attributes?.onRightIconClick,
              showBackConfirm: item?.attributes?.showBackConfirm,
              navigateTo: item?.attributes?.navigateTo,
              rightIconStyle: {
                transform:
                  item?.attributes?.rightIcon === "how_it_work"
                    ? "none"
                    : "scaleX(-1)",
              },
            },
          };

        case HEADER_TYPES.ONBOARDING_HEADER: {
          const containerStyle = safeJsonParse(
            item?.attributes?.containerStyle,
            {}
          );
          const logoStyle = safeJsonParse(item?.attributes?.logoStyle, {});
          const btnStyle = safeJsonParse(item?.attributes?.btnStyle, {});
          return {
            Component: mapping[HEADER_TYPES.ONBOARDING_HEADER],
            props: {
              type: HEADER_TYPES.ONBOARDING_HEADER,
              containerStyle: containerStyle,
              logoStyle: logoStyle,
              btnStyle: btnStyle,
              hideBtn: item?.attributes?.hideBtn,
              darkLogo: item?.attributes?.darkLogo,
            },
          };
        }

        default:
          return null;
      }
    })
    .filter(Boolean);
};
